//
// Autogenerated by Thrift Compiler (0.13.0)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
"use strict";

var thrift = require('thrift');
var Thrift = thrift.Thrift;
var Q = thrift.Q;
var Int64 = require('node-int64');


var ttypes = require('./notes-api_types');
//HELPER FUNCTIONS AND STRUCTURES

var NotesService_loadNotes_args = function(args) {
  this.categoryId = null;
  if (args) {
    if (args.categoryId !== undefined && args.categoryId !== null) {
      this.categoryId = args.categoryId;
    }
  }
};
NotesService_loadNotes_args.prototype = {};
NotesService_loadNotes_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 1:
      if (ftype == Thrift.Type.STRING) {
        this.categoryId = input.readString();
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

NotesService_loadNotes_args.prototype.write = function(output) {
  output.writeStructBegin('NotesService_loadNotes_args');
  if (this.categoryId !== null && this.categoryId !== undefined) {
    output.writeFieldBegin('categoryId', Thrift.Type.STRING, 1);
    output.writeString(this.categoryId);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var NotesService_loadNotes_result = function(args) {
  this.success = null;
  if (args) {
    if (args.success !== undefined && args.success !== null) {
      this.success = Thrift.copyList(args.success, [ttypes.NoteTO]);
    }
  }
};
NotesService_loadNotes_result.prototype = {};
NotesService_loadNotes_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 0:
      if (ftype == Thrift.Type.LIST) {
        this.success = [];
        var _rtmp31 = input.readListBegin();
        var _size0 = _rtmp31.size || 0;
        for (var _i2 = 0; _i2 < _size0; ++_i2) {
          var elem3 = null;
          elem3 = new ttypes.NoteTO();
          elem3.read(input);
          this.success.push(elem3);
        }
        input.readListEnd();
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

NotesService_loadNotes_result.prototype.write = function(output) {
  output.writeStructBegin('NotesService_loadNotes_result');
  if (this.success !== null && this.success !== undefined) {
    output.writeFieldBegin('success', Thrift.Type.LIST, 0);
    output.writeListBegin(Thrift.Type.STRUCT, this.success.length);
    for (var iter4 in this.success) {
      if (this.success.hasOwnProperty(iter4)) {
        iter4 = this.success[iter4];
        iter4.write(output);
      }
    }
    output.writeListEnd();
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var NotesService_saveNote_args = function(args) {
  this.updateNode = null;
  if (args) {
    if (args.updateNode !== undefined && args.updateNode !== null) {
      this.updateNode = new ttypes.UpdateNoteTO(args.updateNode);
    }
  }
};
NotesService_saveNote_args.prototype = {};
NotesService_saveNote_args.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    var fid = ret.fid;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    switch (fid) {
      case 1:
      if (ftype == Thrift.Type.STRUCT) {
        this.updateNode = new ttypes.UpdateNoteTO();
        this.updateNode.read(input);
      } else {
        input.skip(ftype);
      }
      break;
      case 0:
        input.skip(ftype);
        break;
      default:
        input.skip(ftype);
    }
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

NotesService_saveNote_args.prototype.write = function(output) {
  output.writeStructBegin('NotesService_saveNote_args');
  if (this.updateNode !== null && this.updateNode !== undefined) {
    output.writeFieldBegin('updateNode', Thrift.Type.STRUCT, 1);
    this.updateNode.write(output);
    output.writeFieldEnd();
  }
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var NotesService_saveNote_result = function(args) {
};
NotesService_saveNote_result.prototype = {};
NotesService_saveNote_result.prototype.read = function(input) {
  input.readStructBegin();
  while (true) {
    var ret = input.readFieldBegin();
    var ftype = ret.ftype;
    if (ftype == Thrift.Type.STOP) {
      break;
    }
    input.skip(ftype);
    input.readFieldEnd();
  }
  input.readStructEnd();
  return;
};

NotesService_saveNote_result.prototype.write = function(output) {
  output.writeStructBegin('NotesService_saveNote_result');
  output.writeFieldStop();
  output.writeStructEnd();
  return;
};

var NotesServiceClient = exports.Client = function(output, pClass) {
  this.output = output;
  this.pClass = pClass;
  this._seqid = 0;
  this._reqs = {};
};
NotesServiceClient.prototype = {};
NotesServiceClient.prototype.seqid = function() { return this._seqid; };
NotesServiceClient.prototype.new_seqid = function() { return this._seqid += 1; };

NotesServiceClient.prototype.loadNotes = function(categoryId, callback) {
  this._seqid = this.new_seqid();
  if (callback === undefined) {
    var _defer = Q.defer();
    this._reqs[this.seqid()] = function(error, result) {
      if (error) {
        _defer.reject(error);
      } else {
        _defer.resolve(result);
      }
    };
    this.send_loadNotes(categoryId);
    return _defer.promise;
  } else {
    this._reqs[this.seqid()] = callback;
    this.send_loadNotes(categoryId);
  }
};

NotesServiceClient.prototype.send_loadNotes = function(categoryId) {
  var output = new this.pClass(this.output);
  var params = {
    categoryId: categoryId
  };
  var args = new NotesService_loadNotes_args(params);
  try {
    output.writeMessageBegin('loadNotes', Thrift.MessageType.CALL, this.seqid());
    args.write(output);
    output.writeMessageEnd();
    return this.output.flush();
  }
  catch (e) {
    delete this._reqs[this.seqid()];
    if (typeof output.reset === 'function') {
      output.reset();
    }
    throw e;
  }
};

NotesServiceClient.prototype.recv_loadNotes = function(input,mtype,rseqid) {
  var callback = this._reqs[rseqid] || function() {};
  delete this._reqs[rseqid];
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(input);
    input.readMessageEnd();
    return callback(x);
  }
  var result = new NotesService_loadNotes_result();
  result.read(input);
  input.readMessageEnd();

  if (null !== result.success) {
    return callback(null, result.success);
  }
  return callback('loadNotes failed: unknown result');
};

NotesServiceClient.prototype.saveNote = function(updateNode, callback) {
  this._seqid = this.new_seqid();
  if (callback === undefined) {
    var _defer = Q.defer();
    this._reqs[this.seqid()] = function(error, result) {
      if (error) {
        _defer.reject(error);
      } else {
        _defer.resolve(result);
      }
    };
    this.send_saveNote(updateNode);
    return _defer.promise;
  } else {
    this._reqs[this.seqid()] = callback;
    this.send_saveNote(updateNode);
  }
};

NotesServiceClient.prototype.send_saveNote = function(updateNode) {
  var output = new this.pClass(this.output);
  var params = {
    updateNode: updateNode
  };
  var args = new NotesService_saveNote_args(params);
  try {
    output.writeMessageBegin('saveNote', Thrift.MessageType.CALL, this.seqid());
    args.write(output);
    output.writeMessageEnd();
    return this.output.flush();
  }
  catch (e) {
    delete this._reqs[this.seqid()];
    if (typeof output.reset === 'function') {
      output.reset();
    }
    throw e;
  }
};

NotesServiceClient.prototype.recv_saveNote = function(input,mtype,rseqid) {
  var callback = this._reqs[rseqid] || function() {};
  delete this._reqs[rseqid];
  if (mtype == Thrift.MessageType.EXCEPTION) {
    var x = new Thrift.TApplicationException();
    x.read(input);
    input.readMessageEnd();
    return callback(x);
  }
  var result = new NotesService_saveNote_result();
  result.read(input);
  input.readMessageEnd();

  callback(null);
};
var NotesServiceProcessor = exports.Processor = function(handler) {
  this._handler = handler;
};
NotesServiceProcessor.prototype.process = function(input, output) {
  var r = input.readMessageBegin();
  if (this['process_' + r.fname]) {
    return this['process_' + r.fname].call(this, r.rseqid, input, output);
  } else {
    input.skip(Thrift.Type.STRUCT);
    input.readMessageEnd();
    var x = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN_METHOD, 'Unknown function ' + r.fname);
    output.writeMessageBegin(r.fname, Thrift.MessageType.EXCEPTION, r.rseqid);
    x.write(output);
    output.writeMessageEnd();
    output.flush();
  }
};
NotesServiceProcessor.prototype.process_loadNotes = function(seqid, input, output) {
  var args = new NotesService_loadNotes_args();
  args.read(input);
  input.readMessageEnd();
  if (this._handler.loadNotes.length === 1) {
    Q.fcall(this._handler.loadNotes.bind(this._handler),
      args.categoryId
    ).then(function(result) {
      var result_obj = new NotesService_loadNotes_result({success: result});
      output.writeMessageBegin("loadNotes", Thrift.MessageType.REPLY, seqid);
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    }).catch(function (err) {
      var result;
      result = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
      output.writeMessageBegin("loadNotes", Thrift.MessageType.EXCEPTION, seqid);
      result.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  } else {
    this._handler.loadNotes(args.categoryId, function (err, result) {
      var result_obj;
      if ((err === null || typeof err === 'undefined')) {
        result_obj = new NotesService_loadNotes_result((err !== null || typeof err === 'undefined') ? err : {success: result});
        output.writeMessageBegin("loadNotes", Thrift.MessageType.REPLY, seqid);
      } else {
        result_obj = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
        output.writeMessageBegin("loadNotes", Thrift.MessageType.EXCEPTION, seqid);
      }
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  }
};
NotesServiceProcessor.prototype.process_saveNote = function(seqid, input, output) {
  var args = new NotesService_saveNote_args();
  args.read(input);
  input.readMessageEnd();
  if (this._handler.saveNote.length === 1) {
    Q.fcall(this._handler.saveNote.bind(this._handler),
      args.updateNode
    ).then(function(result) {
      var result_obj = new NotesService_saveNote_result({success: result});
      output.writeMessageBegin("saveNote", Thrift.MessageType.REPLY, seqid);
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    }).catch(function (err) {
      var result;
      result = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
      output.writeMessageBegin("saveNote", Thrift.MessageType.EXCEPTION, seqid);
      result.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  } else {
    this._handler.saveNote(args.updateNode, function (err, result) {
      var result_obj;
      if ((err === null || typeof err === 'undefined')) {
        result_obj = new NotesService_saveNote_result((err !== null || typeof err === 'undefined') ? err : {success: result});
        output.writeMessageBegin("saveNote", Thrift.MessageType.REPLY, seqid);
      } else {
        result_obj = new Thrift.TApplicationException(Thrift.TApplicationExceptionType.UNKNOWN, err.message);
        output.writeMessageBegin("saveNote", Thrift.MessageType.EXCEPTION, seqid);
      }
      result_obj.write(output);
      output.writeMessageEnd();
      output.flush();
    });
  }
};
